// removed by extract-text-webpack-plugin
module.exports = {"authorizationOptions":"AuthorizationOptions__authorizationOptions","title":"AuthorizationOptions__title","providerLogo":"AuthorizationOptions__providerLogo","message":"AuthorizationOptions__message","button":"AuthorizationOptions__button","growDotQello":"AuthorizationOptions__growDotQello","growDotBlue":"AuthorizationOptions__growDotBlue","growDotGolden":"AuthorizationOptions__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationOptions/AuthorizationOptions.scss
// module id = 1895
// module chunks = 0